module.exports = "/_next/static/images/icon-left-28bcbbdd.png";